import React, { memo } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

const propTypes = {
  msSecureScore: PropTypes.shape({
    currentScore: PropTypes.number.isRequired,
    maxScore: PropTypes.number.isRequired,
  }),
};

const defaultProps = {
  msSecureScore: undefined,
};

function SecurityPostureSecureScore({ msSecureScore }) {
  const intl = useIntl();

  if (!msSecureScore) {
    return null;
  }

  const { currentScore, maxScore } = msSecureScore;

  return (
    <>
      <span>{currentScore}</span>
      <span className="Uic-SecurityPostureTable-maxScore">
        /{intl.formatNumber(maxScore / 100, {
          style: "percent",
          maximumFractionDigits: 2,
        })}
      </span>
    </>
  );
}

SecurityPostureSecureScore.propTypes = propTypes;
SecurityPostureSecureScore.defaultProps = defaultProps;

export default memo(SecurityPostureSecureScore);
